const INITIAL_STATE = {
  list: [],
  detail: null,
  categories: [],
  loading: false,
  loadingDetail: false,
  submitting: false,
  commentSubmitting: false,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'CLASSIFIED_ADS_LOADING':
      return { ...state, loading: payload };
    case 'CLASSIFIED_ADS_FETCHED':
      return { ...state, loading: false, list: payload };
    case 'CLASSIFIED_AD_LOADING':
      return { ...state, loadingDetail: payload };
    case 'CLASSIFIED_AD_FETCHED':
      return { ...state, loadingDetail: false, detail: payload };
    case 'CLASSIFIED_ADS_CATEGORIES_FETCHED':
      return { ...state, categories: payload };
    case 'CLASSIFIED_AD_SUBMITTING':
      return { ...state, submitting: payload };
    case 'CLASSIFIED_AD_COMMENT_SUBMITTING':
      return { ...state, commentSubmitting: payload };
    default:
      return state;
  }
};
